import type { ChangeEventHandler } from "react";
import { Quill } from "react-quill";
import styles from "./QuillToolbar.module.scss";
import Upload from "./components/upload/Upload";

// override icons
const icons = Quill.import("ui/icons");
icons[
  "bold"
] = `<svg width="20" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12.7494 9.83329C13.1575 9.58483 13.5018 9.24448 13.755 8.83937C14.0082 8.43426 14.1632 7.9756 14.2078 7.49996C14.2155 7.06986 14.1384 6.64246 13.9809 6.24215C13.8235 5.84185 13.5886 5.47649 13.2899 5.16695C12.9912 4.85741 12.6345 4.60974 12.24 4.43811C11.8456 4.26647 11.4212 4.17422 10.9911 4.16663H5.58276V15.8333H11.4161C11.8254 15.8289 12.2298 15.744 12.6063 15.5833C12.9828 15.4227 13.3239 15.1894 13.6102 14.8969C13.8965 14.6044 14.1224 14.2584 14.275 13.8786C14.4276 13.4987 14.5038 13.0926 14.4994 12.6833V12.5833C14.4997 12.0059 14.3352 11.4404 14.0252 10.9533C13.7152 10.4661 13.2726 10.0776 12.7494 9.83329ZM7.24943 5.83329H10.7494C11.1046 5.8223 11.4546 5.9202 11.7525 6.11384C12.0504 6.30748 12.282 6.5876 12.4161 6.91663C12.5518 7.35645 12.5079 7.83212 12.294 8.23967C12.0801 8.64723 11.7135 8.95352 11.2744 9.09163C11.1039 9.1416 10.9271 9.16685 10.7494 9.16663H7.24943V5.83329ZM11.0828 14.1666H7.24943V10.8333H11.0828C11.4379 10.8223 11.7879 10.9202 12.0858 11.1138C12.3837 11.3075 12.6153 11.5876 12.7494 11.9166C12.8852 12.3564 12.8413 12.8321 12.6273 13.2397C12.4134 13.6472 12.0468 13.9535 11.6078 14.0916C11.4372 14.1416 11.2604 14.1669 11.0828 14.1666Z" fill="black"/>
</svg>
`;
icons[
  "italic"
] = `<svg width="20" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M9.8409 7.49996H11.5076L9.67424 15.8333H8.00757L9.8409 7.49996ZM11.2409 4.16663C11.0761 4.16663 10.915 4.2155 10.7779 4.30707C10.6409 4.39864 10.5341 4.52878 10.471 4.68106C10.4079 4.83333 10.3914 5.00088 10.4236 5.16253C10.4557 5.32419 10.5351 5.47267 10.6516 5.58921C10.7682 5.70576 10.9167 5.78513 11.0783 5.81728C11.24 5.84943 11.4075 5.83293 11.5598 5.76986C11.7121 5.70679 11.8422 5.59998 11.9338 5.46293C12.0254 5.32589 12.0742 5.16478 12.0742 4.99996C12.0742 4.77895 11.9864 4.56698 11.8302 4.4107C11.6739 4.25442 11.4619 4.16663 11.2409 4.16663Z" fill="black"/>
</svg>
`;
icons[
  "underline"
] = `<svg width="20" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M15.8744 16.6666V18.3333H4.20776V16.6666H15.8744ZM13.3744 11.0125C13.347 11.5624 13.1837 12.0971 12.8992 12.5686C12.6147 13.04 12.2178 13.4337 11.744 13.7143C11.2702 13.995 10.7343 14.1539 10.1841 14.1768C9.63391 14.1997 9.08661 14.086 8.5911 13.8458C8.01996 13.5987 7.5356 13.1867 7.20007 12.6627C6.86454 12.1386 6.69312 11.5262 6.70776 10.9041V4.17079H5.0411V11.0125C5.06929 11.797 5.28181 12.5638 5.66144 13.2509C6.04108 13.938 6.57717 14.5261 7.22632 14.9675C7.87547 15.4089 8.61943 15.6913 9.39799 15.7918C10.1766 15.8922 10.9678 15.808 11.7078 15.5458C12.692 15.2177 13.546 14.5843 14.1455 13.7375C14.7449 12.8907 15.0587 11.8748 15.0411 10.8375V4.17079H13.3744V11.0125ZM13.3744 4.16663H15.0411H13.3744ZM6.70776 4.16663H5.0411H6.70776Z" fill="black"/>
</svg>
`;
icons[
  "strike"
] = `<svg width="20" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M2.54102 10.1691H17.541V11.4191H13.9029C14.1002 11.8335 14.1999 12.2876 14.194 12.7465C14.2057 13.182 14.1123 13.6138 13.9216 14.0054C13.731 14.397 13.4487 14.7369 13.0988 14.9963C12.2559 15.5894 11.2391 15.884 10.2098 15.8333C9.45765 15.8384 8.71285 15.6854 8.02365 15.3842C7.39424 15.1231 6.84866 14.6941 6.44645 14.144C6.07611 13.6189 5.8807 12.9904 5.88798 12.3478V12.2533H6.12734V12.2524H6.41192V12.2533H7.55768V12.3478C7.54463 12.6406 7.60253 12.9323 7.72646 13.1979C7.85039 13.4635 8.03668 13.6952 8.26946 13.8734C8.83397 14.2753 9.51768 14.4748 10.2098 14.4394C10.8207 14.4794 11.4281 14.3196 11.9403 13.9843C12.1302 13.8438 12.2828 13.659 12.3847 13.4459C12.4865 13.2329 12.5346 12.9981 12.5247 12.7621C12.538 12.5342 12.4959 12.3064 12.402 12.0982C12.3081 11.8901 12.1652 11.7077 11.9856 11.5668C11.9119 11.5134 11.8355 11.4641 11.7565 11.4191H2.54102V10.1691ZM13.6616 5.88319C13.3103 5.33736 12.8136 4.9005 12.2273 4.62184C11.5738 4.31052 10.8571 4.15473 10.1333 4.16668C9.12401 4.12336 8.13171 4.43671 7.33034 5.05179C6.98631 5.31749 6.7088 5.65958 6.51975 6.05101C6.3307 6.44244 6.23529 6.87248 6.24107 7.30714C6.23815 7.71905 6.32984 8.12613 6.50907 8.49702H8.67297C8.60348 8.45231 8.51849 8.40888 8.46239 8.36315C8.29284 8.23808 8.1552 8.07475 8.06066 7.88646C7.96613 7.69816 7.91738 7.49021 7.91837 7.27952C7.90579 7.03901 7.95137 6.79902 8.05123 6.57986C8.15109 6.3607 8.3023 6.16884 8.49205 6.02052C8.97212 5.68757 9.55008 5.52546 10.1333 5.56016C10.7674 5.51985 11.3936 5.71868 11.8883 6.11741C12.0952 6.31224 12.2572 6.54974 12.3631 6.81345C12.469 7.07716 12.5163 7.36076 12.5016 7.64456V7.73907H14.1709V7.64456C14.1737 7.02072 13.9969 6.40926 13.6616 5.88319Z" fill="black"/>
</svg>
`;
icons["align"][
  ""
] = `<svg width="20" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M2.54102 15H7.54102V13.3333H2.54102V15ZM2.54102 9.16667V10.8333H12.541V9.16667H2.54102ZM2.54102 5V6.66667H17.541V5H2.54102Z" fill="black"/>
</svg>
`;

icons["undo"] = `<svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.4 9.4C8.7 9.7 7.2 10.3 5.8 11.4L3 8.5V15.5H10L7.3 12.8C11 10.2 16.1 11 18.8 14.7C19 15 19.2 15.2 19.3 15.5L21.1 14.6C18.9 10.8 14.7 8.7 10.4 9.4Z"
      fill="black"
    />
  </svg>`;
icons["redo"] = `<svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.6 9.4C15.3 9.7 16.8 10.3 18.2 11.4L21 8.5V15.5H14L16.7 12.8C13 10.1 7.9 11 5.3 14.7C5.1 15 4.9 15.2 4.8 15.5L3 14.6C5.1 10.8 9.3 8.7 13.6 9.4Z"
      fill="black"
    />
  </svg>`;

icons["list"][
  "ordered"
] = `<svg width="20" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M2.12427 13.3333H3.79093V13.75H2.9576V14.5833H3.79093V15H2.12427V15.8333H4.62427V12.5H2.12427V13.3333ZM2.9576 7.49996H3.79093V4.16663H2.12427V4.99996H2.9576V7.49996ZM2.12427 9.16663H3.62427L2.12427 10.9166V11.6666H4.62427V10.8333H3.12427L4.62427 9.08329V8.33329H2.12427V9.16663ZM6.29093 4.99996V6.66663H17.9576V4.99996H6.29093ZM6.29093 15H17.9576V13.3333H6.29093V15ZM6.29093 10.8333H17.9576V9.16663H6.29093V10.8333Z" fill="black"/>
</svg>
`;

icons["list"][
  "bullet"
] = `<svg width="20" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M3.37427 8.75004C2.7076 8.75004 2.12427 9.33337 2.12427 10C2.12427 10.6667 2.7076 11.25 3.37427 11.25C4.04093 11.25 4.62427 10.6667 4.62427 10C4.62427 9.33337 4.04093 8.75004 3.37427 8.75004ZM3.37427 4.58337C2.7076 4.58337 2.12427 5.16671 2.12427 5.83337C2.12427 6.50004 2.7076 7.08337 3.37427 7.08337C4.04093 7.08337 4.62427 6.50004 4.62427 5.83337C4.62427 5.16671 4.04093 4.58337 3.37427 4.58337ZM3.37427 12.9167C2.7076 12.9167 2.12427 13.5 2.12427 14.1667C2.12427 14.8334 2.7076 15.4167 3.37427 15.4167C4.04093 15.4167 4.62427 14.8334 4.62427 14.1667C4.62427 13.5 4.04093 12.9167 3.37427 12.9167ZM6.29093 5.00004V6.66671H17.9576V5.00004H6.29093ZM6.29093 15H17.9576V13.3334H6.29093V15ZM6.29093 10.8334H17.9576V9.16671H6.29093V10.8334Z" fill="black"/>
</svg>
`;

type Props = {
  id: string;
  onUpload?: ChangeEventHandler<HTMLInputElement>;
  isOnComplete: boolean;
};

// Quill Toolbar component
export const QuillToolbar = ({ id, onUpload, isOnComplete }: Props) => (
  <div className={styles["toolbar"]} id={id}>
    <span className={`${styles["toolbar__button-group"]} ql-formats`}>
      <button className={`${styles["toolbar__button"]} ql-bold`} />
      <button className={`${styles["toolbar__button"]} ql-italic`} />
      <button className={`${styles["toolbar__button"]} ql-underline`} />
      <button className={`${styles["toolbar__button"]} ql-strike`} />
    </span>
    <span className={`${styles["toolbar__button-group"]} ql-formats`}>
      <button className={`${styles["toolbar__button"]} ql-align`} value="" />
      <button
        className={`${styles["toolbar__button"]} ql-list`}
        value="ordered"
      />
      <button
        className={`${styles["toolbar__button"]} ql-list`}
        value="bullet"
      />
    </span>

    <span className={`${styles["toolbar__button-group"]} ql-formats`}>
      <button className={`${styles["toolbar__button"]} ql-undo`} />
      <button className={`${styles["toolbar__button"]} ql-redo`} />
    </span>

    {onUpload && isOnComplete && (
      <span
        className={`${styles["toolbar__button-group"]} ${styles["toolbar__button-group--upload-group"]} ql-formats`}
      >
        <Upload
          className={`${styles["toolbar__button"]} ${styles["toolbar__button--upload"]}`}
          onUpload={onUpload}
        />
      </span>
    )}
  </div>
);

export default QuillToolbar;
